import request from '@/utils/request';

export function login(data) {
  return request({
      // baseURL: 'https://service.eswonline.com',
      url: '/api/v2/auth/student',
      method: 'POST',
      data: data,
    })
}

export function userinfo() {
    return request({
      url: '/api/v1/userinfo',
      method: 'get',
    })
}

export function captcha() {
  return request({
      // baseURL: 'https://service.eswonline.com',
      url: '/api/v2/captcha',
      method: 'POST',
  })
}


// WEBPACK FOOTER //
// ./src/api/login.js